import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import publicUsersApi from '@api/public-user'
import NewUsersSearch from "./Search";
import NewUsersChart from "./Chart";


function NewUsersReport() {
  const [state, setState] = useState({
    isFetched: false,
    downloadUrl: "",
    data : []
  });
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (params={}) => {
    publicUsersApi.getNewUsers({
        params
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <NewUsersSearch search={fetch}/>
        </Card>
      </Col>
      <Col span={24}>
        {state.data.length > 0 && <NewUsersChart data={state.data}/>}
      </Col>
    </Row>
  )
}

export default NewUsersReport;

